import { Check } from "@material-ui/icons";
import { Box, Grid, Typography } from "@mui/material";
import {
  CheckboxInput,
  MonthYearRangePicker,
  PrimaryButton,
  PrimaryDeleteButton,
} from "components";
import moment from "moment-timezone";

const PeriodSubscriptionItem = ({
  disabled,
  onDelete,
  startDate,
  endDate,
  handleChangeStartDate,
  handleChangeEndDate,
  status,
  handleSubmit,
  loadingSubmit,
  loadingDelete,
  handleToggle,
  loadingCheckbox,
  periodId,
}) => {
  const newPeriod = !periodId;
  console.log({ periodId, newPeriod });
  return (
    <Box
      bgcolor="white"
      borderRadius="5px"
      p={periodId ? "8px 8px 8px 0" : "8px"}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Grid container alignItems="center">
            {periodId && (
              <Grid item>
                <CheckboxInput
                  checked={status}
                  onChange={handleToggle}
                  isLoading={loadingCheckbox}
                  disabled={disabled}
                />
              </Grid>
            )}
            <Grid item>
              <MonthYearRangePicker
                startDate={startDate}
                endDate={endDate}
                handleChangeStartDate={handleChangeStartDate}
                handleChangeEndDate={handleChangeEndDate}
                endMaxDate={moment().add(5, "years")}
                disabled={periodId || disabled}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container columnGap={1} alignItems="center">
            <Grid item>
              {newPeriod ? (
                <PrimaryButton
                  label={loadingSubmit ? "Saving..." : "Save"}
                  loading={loadingSubmit}
                  onClick={handleSubmit}
                  disabled={(!startDate && !endDate) || loadingSubmit}
                />
              ) : (
                <Grid container alignItems="center">
                  {status && (
                    <Grid item color="#32B880">
                      <Check />
                    </Grid>
                  )}
                  <Grid item>
                    <Typography
                      fontSize="12px"
                      color={status ? "#32B880" : "#CFD0D8"}
                    >{`${status ? "Active" : "Inactive"} Period`}</Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item>
              <PrimaryDeleteButton
                onClick={onDelete}
                loading={loadingDelete}
                disabled={disabled || loadingDelete}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PeriodSubscriptionItem;
